<mat-nav-list *ngIf="(isHandset$ | async)!.matches">
   <mat-list-item align=center *ngFor="let link of links">
      <a matListItemLine [routerLink]="'/'+link.page" routerLinkActive="router"  [routerLinkActiveOptions]="{ exact: true }">
       <mat-icon [inline]="true" class="material-icons-round"  [fontIcon]="link.icon"></mat-icon>
      <span matListItemLine>{{link.text}}</span>
   </a>
   </mat-list-item>
</mat-nav-list>

   <!--*ngIf="(isHandset$ | async)!.matches" let p of pages  routerLinkActive="router-link-active" [routerLinkActiveOptions]="{ exact: true }"-->